import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaArrowUp } from 'react-icons/fa';

import { Odom } from '../../HomePage/components/Highlights';

const BeyondPaperGraphics = () => (

  <Container fluid>
    <Row>
      <Col xs={6} md={4}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <FortyFiveMil />
        </Row>
      </Col>
      <Col xs={6} md={4}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <Brokerages />
        </Row>
      </Col>
      <Col xs={6} md={4}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <Insurers />
        </Row>
      </Col>
      <Col xs={6} md={4}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <Sixteen />
        </Row>
      </Col>
      <Col xs={6} md={4}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <TwentyEight />
        </Row>
      </Col>
      <Col xs={6} md={4}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <NinetyNine />
        </Row>
      </Col>
    </Row>
  </Container>
)

const FortyFiveMil = () => (
  <Col style={{ marginTop: 20, padding: 20 }}>
    <Row style={{
      display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'
    }}>
      <Odom number={45} text=" million" preText="+"
        // style={{  paddingLeft: 20 }}
        odomStyle={{
          fontSize: 28,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#8A9E76',
          lineHeight: 1,
          padding: 0,
        }} />
    </Row>
    <Row>
      <Col>
      <p style={{
        fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
          textAlign: 'center'
        }}>eDocs sent
      </p>
      </Col>
    </Row>
  </Col>
)

const Insurers = () => (
  <Col style={{ marginTop: 20, padding: 20 }}>
    <Row style={{
      display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'
    }}>
      <Odom number={76}
        // style={{ justifyContent: 'flex-start', paddingLeft: 20 }}
        odomStyle={{
          fontSize: 28,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#8A9E76',
          lineHeight: 1,
          padding: 0,
        }} />
    </Row>
    <Row>
      <Col>
      <p style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#4D788D',
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
        lineHeight: 1.2,
        textAlign: 'center'
      }}>
        <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}>insurers</span> sent eDocs
      </p>
      </Col>
    </Row>
  </Col>
)

const Sixteen = () => (
  <Col style={{ backgroundColor: '#F3F5ED', marginTop: 20, padding: 20 }}>
    <Row style={{paddingLeft: 38}}>
      <Odom number={16} text="%" preText="+" 
      style={{ justifyContent: 'flex-end'}}
      odomStyle={{
        fontSize: 28,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        lineHeight: 1,
        padding: 0,
      }} />
      <Col style={{paddingLeft: 4}}>
        <FaArrowUp
          size={28}
          color='#1B526D'
        />
      </Col>
    </Row>
    <Row>
    <p style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#4D788D',
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
        lineHeight: 1.2,
        textAlign: 'center'
      }}>growth in 
        <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}> Personal Lines eDocs</span>
      </p>
    </Row>
  </Col>
)

const NinetyNine = () => (
  <Col style={{ backgroundColor: '#F3F5ED', marginTop: 20, padding: 20 }}>
    <Row>
      <Odom number={99} text="%" odomStyle={{
        fontSize: 28,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        lineHeight: 1,
        padding: 0,
      }} />
    </Row>
    <Row>
    <p style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#4D788D',
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
        lineHeight: 1.2,
        textAlign: 'center'
      }}>of
        <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}> members found eDocs </span>to be useful or <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}>very useful</span>
      </p>
    </Row>
  </Col>
)

const TwentyEight = () => (
  <Col style={{ marginTop: 20, padding: 20 }}>
    <Row style={{
      display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', paddingLeft: 38
    }}>
      <Odom number={28} text="%" preText="+"
        style={{ justifyContent: 'flex-end' }}
        odomStyle={{
          fontSize: 28,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#8A9E76',
          lineHeight: 1,
          padding: 0,
        }} />
        <Col style={{paddingLeft: 4}}>
        <FaArrowUp
          size={28}
          color='#899D75'
        />
      </Col>
    </Row>
    <Row>
      <Col>
      <p style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#4D788D',
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
        lineHeight: 1.2,
        textAlign: 'center'
      }}>growth in
        <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}> Commercial Lines eDocs</span>
      </p>
      </Col>
    </Row>
  </Col>
)

const Brokerages = () => (
  <Col style={{ backgroundColor: '#F3F5ED', marginTop: 20, padding: 20 }}>
    <Row style={{
      // display: 'flex', flexDirection: 'row', justifyContent: 'center'
    }}>
      <Odom number={2216}
        // style={{ justifyContent: 'flex-start', paddingLeft: 20 }}
        format="(,ddd)"
        odomStyle={{
          fontSize: 28,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#1B526D',
          lineHeight: 1,
          padding: 0,
        }} />
    </Row>
    <Row>
      <Col>
      <p style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#4D788D',
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
        lineHeight: 1.2,
        textAlign: 'center'
      }}>
        <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}>brokerages</span> received eDocs
      </p>
      </Col>
    </Row>
  </Col>
)

export default BeyondPaperGraphics;
